/**
 * Types and constants shared across CouponCodes flows.
 */

export type DiscountType =
  | "percent_off"
  | "dollar_off"
  | "bogo"
  | "free_shipping"
  | "other";

export const DISCOUNT_TYPES: { value: DiscountType; label: string }[] = [
  { value: "percent_off", label: "% Off (Fixed Amount)" },
  { value: "dollar_off", label: "$ Off (Fixed Amount)" },
  { value: "bogo", label: "Buy X Get Y" },
  { value: "free_shipping", label: "Free Shipping" },
];

export function slugifyDiscountName(name: string): string {
  return name.toLowerCase().replace(/ /g, "-");
}
